import React, { useRef, useState, useEffect, useContext } from 'react'
import { components, constants, useServices } from 'cng-web-lib'
import { Chip, Typography } from '@material-ui/core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { A6ATranslationContext } from './contexts/A6ATranslationContext'
import pathMap from 'src/paths/pathMap'
import A6aApiUrls from 'src/apiUrls/A6aApiUrls'
import Table from 'src/components/aciacehighway/Table'
import ConfirmDialog from 'src/views/common/ConfirmDialog'
import CngBackdrop from 'src/components/cngcomponents/CngBackDrop';
import TemplateSelectDialogWithOptionA6A from 'src/components/aciacehighway/TemplateSelectDialogWithOptionA6A'
import { getStatusMetadata } from '../../common/NACommon'
import { FileForUserGetPartyId,FileForUserGetUserDetails,GetFilterByUserIdCriteria,FileForUserGetCurrentLoginId } from 'src/common/FileForUserCommon'
import { format } from 'date-fns'
import moment from 'moment-timezone'
import _ from 'lodash'
import UserProfileApiUrls from "src/apiUrls/UserProfileApiUrls";
import FileForUserContext from 'src/contexts/FileForUserContext'


const { table: { useFetchCodeMaintenanceLookup }, CngGridItem } = components

const { filter: { EQUAL, IN, LIKE, BETWEEN } } = constants

function TablePage(props) {
  const { history, location, showNotification } = props
  const { createRecord, deleteRecord, securedSendRequest } = useServices()
  const { getTranslatedText } = useContext(A6ATranslationContext)

  const fetchCodeMaintenanceLookup = useFetchCodeMaintenanceLookup()

  const tableRef = useRef(null)

  const [lookups, setLookups] = useState(null)
  const [loading, setLoading] = useState(false)
  const [a6aTemplateDialog, setA6aTemplateDialog] = useState(false)
  const [confirmDelete, setConfirmDelete] = useState({ open: false, a6a: null })
  const [confirmDeleteTemplate, setConfirmDeleteTemplate] = useState({ open: false, a6a: null })
  const [confirmMassDelete, setConfirmMassDelete] = useState({ open: false, a6a: [] })
  const [confirmSubmit, setConfirmSubmit] = useState({ open: false, a6a: [] })
  const [sbPartyIdList, setSBPartyIdList] = useState([])
  const [sbPartyIdFetched, setSBPartyIdFetched] = useState(false)
  const [codeMaintenanceFetched, setCodeMaintenanceFetched] = useState(false)
  const [hqAdmin, setHqAdmin] = useState(false)
  const { partyConfigFetched } = useContext(FileForUserContext)

  let filter = GetFilterByUserIdCriteria("ACIOCN")

  function getLookupValue(name, value) {
    if (!lookups) return value

    return lookups[name] && lookups[name][value] ? lookups[name][value] : value
  }

  useEffect(() => {
    Promise.all([
      // Document Type
      fetchCodeMaintenanceLookup(constants.CodeMaintenanceType.CODE_MASTER, undefined,
        [{ field: 'codeType', operator: EQUAL, value: 'A6A_DOC_TYPE' }],
        undefined, 'code'
      ),
      // Customs Procedure
      fetchCodeMaintenanceLookup(constants.CodeMaintenanceType.CODE_MASTER, undefined,
        [{
          field: 'codeType', operator: IN,
         value: 'A6A_CUSTOMS_PROCEDURE_SUPP'
        }], undefined, 'code'
      ),
      // Message Function
      fetchCodeMaintenanceLookup(constants.CodeMaintenanceType.CODE_MASTER, undefined,
        [{
          field: 'codeType', operator: IN,
          value: 'MESSAGE_FUNCTION'
        }], undefined, 'code'
      ),
      // Supplementary Match
      fetchCodeMaintenanceLookup(constants.CodeMaintenanceType.CODE_MASTER, undefined,
        [{
          field: 'codeType', operator: IN,
          value: 'SUPPLEMENTARY_MATCH'
        }], undefined, 'code'
      ),
      // Risk Assessment Status
      fetchCodeMaintenanceLookup(constants.CodeMaintenanceType.CODE_MASTER, undefined,
        [{
          field: 'codeType', operator: IN,
          value: 'RISK_ASSESSMENT_STATUS'
        }], undefined, 'code'
      ),
       //HQ_ADMINISTRATOR
       fetchCodeMaintenanceLookup(
        constants.CodeMaintenanceType.CODE_MASTER,
        undefined,
        [{ field: 'codeType', operator: EQUAL, value: 'HQ_ADMINISTRATOR' },
          { field: 'code', operator: EQUAL, value: FileForUserGetCurrentLoginId() }
        ],
        undefined,
        'code'
      )
    ]).then(([docFormat, customsProcedure, messageFunction, supplementaryMatch, riskAssessmentStatus,hqAdmin]) => {
      setLookups({ docFormat, customsProcedure, messageFunction, supplementaryMatch, riskAssessmentStatus })

      if(hqAdmin && hqAdmin[FileForUserGetCurrentLoginId()] == "true"){
        setHqAdmin(true)
      }
      setCodeMaintenanceFetched(true);
    })

    let loginId = "";
    let userPreference = localStorage.getItem("userPreference");
    let fileForUserDetails = sessionStorage.getItem("fileForUserDetails");
    if (fileForUserDetails != null && fileForUserDetails != undefined) {
      setSBPartyIdList([])
      setSBPartyIdFetched(true);
    } else {
      let userPreferenceJSON = JSON.parse(userPreference);
      loginId = userPreferenceJSON.tprUserDetail.userProfile.loginId;
    }
    console.log("loginId: " + JSON.stringify(loginId));

    if (loginId !== "") {
      function onSuccess(response) {
        setSBPartyIdList(response.data)
        setSBPartyIdFetched(true);
        console.log("sbPartyIdList: " + JSON.stringify(sbPartyIdList));
      }

      function onError(error) {
        console.log("sbPartyIdList Error: " + JSON.stringify(error));
      }

      function onComplete() { }
      const config = {}

      securedSendRequest.execute('POST', UserProfileApiUrls.SB_PARTYID_LIST, { loginId }, onSuccess, onError, onComplete, config, null);

    }
  }, [])

  let columns = [
    {
      field: 'docFormat',
      sortKey: 'docFormat',
      title: getTranslatedText('A6A', 'docFormat'),
      render: (data) => (
        <Typography component='div' variant='inherit' style={{ marginBottom: 4 }}>
          {getLookupValue('docFormat', data.docFormat)}
        </Typography>
      )
    },
    {
      field: 'ccn',
      sortKey: 'ccn',
      title: getTranslatedText('A6A', 'ccn')
    },
    {
      field: 'customsProcedure',
      sortKey: 'customsProcedure',
      title: getTranslatedText('A6A', 'customsProcedure'),
      render: (data) => (
        <Typography component='div' variant='inherit' style={{ marginBottom: 4 }}>
          {getLookupValue('customsProcedure', data.customsProcedure)}
        </Typography>
      )
    },
    {
      field: 'vesselName',
      sortKey: 'vesselName',
      title: getTranslatedText('A6A', 'vesselName')
    },
    {
      field: 'a6aStatus',
      title: getTranslatedText('A6A', 'status'),
      render: (data) => {
        const status = getStatusMetadata(data.a6aStatus)

        return (
          <Chip label={status.label} size='small'
            style={{ backgroundColor: status.color, color: status.contrastColor }}
          />
        )
      }
    },
    {
      field: 'messageFunction',
      sortKey: 'messageFunction',
      title: getTranslatedText('A6A', 'messageFunction'),
      render: (data) => (
        <Typography component='div' variant='inherit' style={{ marginBottom: 4 }}>
          {getLookupValue('messageFunction', data.messageFunction)}
        </Typography>
      )
    },
    {
      field: 'supplementaryMatch',
      sortKey: 'supplementaryMatch',
      title: getTranslatedText('A6A', 'supplementaryMatch'),
      render: (data) => (
        <Typography component='div' variant='inherit' style={{ marginBottom: 4 }}>
          {getLookupValue('supplementaryMatch', data.supplementaryMatch)}
        </Typography>
      )
    },
    {
      field: 'riskAssessmentStatus',
      sortKey: 'riskAssessmentStatus',
      title: getTranslatedText('A6A', 'riskAssessmentStatus'),
      render: (data) => (
        <Typography component='div' variant='inherit' style={{ marginBottom: 4 }}>
          {getLookupValue('riskAssessmentStatus', data.riskAssessmentStatus)}
        </Typography>
      )
    },
    {
      field: 'createdDate',
      sortKey: 'createdDate',
      title: getTranslatedText('A6A', 'creationdatetime'),
      render: (data) => (moment(data.createdDate).tz('Canada/Eastern').format('D MMM YYYY, HH:mm'))
    }
  ]

  let hqAdminColumns = [
    {
      field: 'docFormat',
      sortKey: 'docFormat',
      title: getTranslatedText('A6A', 'docFormat'),
      render: (data) => (
        <Typography component='div' variant='inherit' style={{ marginBottom: 4 }}>
          {getLookupValue('docFormat', data.docFormat)}
        </Typography>
      )
    },
    {
      field: 'ccn',
      sortKey: 'ccn',
      title: getTranslatedText('A6A', 'ccn')
    },
    {
      field: 'customsProcedure',
      sortKey: 'customsProcedure',
      title: getTranslatedText('A6A', 'customsProcedure'),
      render: (data) => (
        <Typography component='div' variant='inherit' style={{ marginBottom: 4 }}>
          {getLookupValue('customsProcedure', data.customsProcedure)}
        </Typography> 
      )
    },
    {
      field: 'vesselName',
      sortKey: 'vesselName',
      title: getTranslatedText('A6A', 'vesselName')
    },
    {
      field: 'a6aStatus',
      title: getTranslatedText('A6A', 'status'),
      render: (data) => {
        const status = getStatusMetadata(data.a6aStatus)

        return (
          <Chip label={status.label} size='small'
            style={{ backgroundColor: status.color, color: status.contrastColor }}
          />
        )
      }
    },
    {
      field: 'messageFunction',
      sortKey: 'messageFunction',
      title: getTranslatedText('A6A', 'messageFunction'),
      render: (data) => (
        <Typography component='div' variant='inherit' style={{ marginBottom: 4 }}>
          {getLookupValue('messageFunction', data.messageFunction)}
        </Typography>
      )
    },
    {
      field: 'supplementaryMatch',
      sortKey: 'supplementaryMatch',
      title: getTranslatedText('A6A', 'supplementaryMatch'),
      render: (data) => (
        <Typography component='div' variant='inherit' style={{ marginBottom: 4 }}>
          {getLookupValue('supplementaryMatch', data.supplementaryMatch)}
        </Typography>
      )
    },
    {
      field: 'riskAssessmentStatus',
      sortKey: 'riskAssessmentStatus',
      title: getTranslatedText('A6A', 'riskAssessmentStatus'),
      render: (data) => (
        <Typography component='div' variant='inherit' style={{ marginBottom: 4 }}>
          {getLookupValue('riskAssessmentStatus', data.riskAssessmentStatus)}
        </Typography>
      )
    },
    {
      field: 'createdByLoginId',
      sortKey: 'createdByLoginId',
      title: getTranslatedText('A6A', 'createdByLoginId')
    },
    {
      field: 'createdDate',
      sortKey: 'createdDate',
      title: getTranslatedText('A6A', 'creationdatetime'),
      render: (data) => (moment(data.createdDate).tz('Canada/Eastern').format('D MMM YYYY, HH:mm'))
    }
  ]

  const filters = [
    {
      label: getTranslatedText('A6A', 'docFormat'),
      type: 'checkbox',
      name: 'docFormat',
      operatorType: IN,
      options: [
        { label: 'A6A Import', value: 'a6a_import', filterValue: { value: '83' } },
        { label: 'A6A Export', value: 'a6a_export', filterValue: { value: '711' } },
        { label: 'A6A Empty', value: 'a6a_empty', filterValue: { value: '695' } },
        { label: 'S10 Supplementary', value: 's10_supplementary', filterValue: { value: '687' } }
      ]
    },
    {
      label: getTranslatedText('A6A', 'ccn'),
      type: 'textfield',
      name: 'ccn',
      operatorType: LIKE
    },
    {
      label: getTranslatedText('A6A', 'customsProcedure'),
      type: 'checkbox',
      name: 'customsProcedure',
      operatorType: IN,
      options: [
        { label: 'In-Transit', value: 'in_transit', filterValue: { value: '23' } },
        { label: 'Imported Goods', value: 'imported_goods', filterValue: { value: '24' } },
        { label: 'Exported Goods', value: 'exported_goods', filterValue: { value: '25' } },
        { label: 'FROB', value: 'frob', filterValue: { value: '26' } }
      ]
    },
    {
      label: getTranslatedText('A6A', 'vesselName'),
      type: 'textfield',
      name: 'vesselName',
      operatorType: LIKE
    },
    {
      label: getTranslatedText('A6A', 'status'),
      type: 'checkbox',
      name: 'a6aStatus',
      operatorType: IN,
      options: [
        { label: 'CBSA Recieved and Processing', value: 'processing', filterValue: { value: '1' } },
        { label: 'Send Successfully', value: 'sent', filterValue: { value: '1048' } },
        { label: 'Send Failed', value: 'send_failed', filterValue: { value: '1049' } },
        { label: 'Accepted', value: 'accepted', filterValue: { value: '1000' } },
        { label: 'Rejected', value: 'rejected', filterValue: { value: '1001' } },
        { label: 'Cancel Accepted', value: 'cancelled', filterValue: { value: '1003' } },
        { label: 'Cancel Rejected', value: 'cancel_rejected', filterValue: { value: '1004' } },
        { label: 'Draft', value: 'draft', filterValue: { value: '1005' } },
        { label: 'Functional Acknowledgement Message Received', value: 'func_received', filterValue: { value: '17' } },
        { label: 'Conveyance Arrived', value: 'arrived', filterValue: { value: '200' } },
        { label: 'Risk Assessment', value: 'risk_assessment', filterValue: { value: '25' } },
        { label: 'Reject Type', value: 'reject_type', filterValue: { value: '14' } },
        { label: 'Batch Error', value: 'batch_error', filterValue: { value: '28' } },
        { label: 'Data Error', value: 'data_error', filterValue: { value: '29' } },
        { label: 'Admin Error', value: 'admin_error', filterValue: { value: '20' } },
        { label: 'Enforce Error', value: 'enforce_error', filterValue: { value: '21' } },
        { label: 'Syntax Error', value: 'syntax_error', filterValue: { value: '22' } },
        { label: 'Supplementary Match Yes', value: 'supp_yes', filterValue: { value: '32' } },
        { label: 'Supplementary Match No', value: 'supp_no', filterValue: { value: '33' } }
      ]
    },
    {
      label: getTranslatedText('A6A', 'messageFunction'),
      type: 'checkbox',
      name: 'messageFunction',
      operatorType: IN,
      options: [
        { label: 'Original', value: 'original', filterValue: { value: '9' } },
        { label: 'Change', value: 'change', filterValue: { value: '4' } },
        { label: 'Cancel', value: 'cancel', filterValue: { value: '1' } },
      ]
    },
    {
      label: getTranslatedText('A6A', 'supplementaryMatch'),
      type: 'checkbox',
      name: 'supplementaryMatch',
      operatorType: IN,
      options: [
        { label: 'Yes', value: 'yes', filterValue: { value: '32' } },
        { label: 'No', value: 'no', filterValue: { value: '33' } },
        { label: 'NA', value: 'na', filterValue: { value: 'NA' } }
      ]
    },
    {
      label: getTranslatedText('A6A', 'riskAssessmentStatus'),
      type: 'checkbox',
      name: 'riskAssessmentStatus',
      operatorType: IN,
      options: [
        { label: 'Cancellation of Do Not Load / Hold / Do Not Unload', value: 'cancellation', filterValue: { value: '1' } },
        { label: 'Do Not Load', value: 'do_not_load', filterValue: { value: '5' } },
        { label: 'Hold / Request For Information', value: 'hold', filterValue: { value: '6' } },
        { label: 'Goods Detained / Do Not Unload', value: 'detained', filterValue: { value: '7' } },
        { label: 'NA', value: 'na', filterValue: { value: 'NA' } }
      ]
    },
    {
      label: getTranslatedText('A6A', 'createdByLoginId'),
      type: 'textfield',
      name: 'createdByLoginId',
      operatorType: LIKE
    },
    {
      label: getTranslatedText('A6A', 'creationdatetime'),
      type: 'daterange',
      name: 'createdDate',
      operatorType: BETWEEN
    },
  ]

  function handleCloneA6A(data) {
    createRecord.execute(
      A6aApiUrls.CLONE, data,
      (data) => { 
        const updatedData = {
          ...data,
          taciOcnA6aContainers: data.taciOcnA6aContainers.map(cont =>
            cont.othContainertypeSize ? { ...cont, containertypeSizeOth: cont.containertypeSize, containertypeSize: 'OTHR' } : cont)
        };
        history.push(`${location.pathname}/add`, updatedData) },
      (error) => { console.log(error) }
    )
  }

  function handleNormalPrint(data) {
    const config = { responseType: 'blob' }

    function onSuccess(response) {
      let blob = new Blob([response.data])

      let first = 'A6AReport'
      let curDate = format(new Date(), 'yyyyMMddHHmmss')
      let filename = first + curDate + '.pdf'
      let url = window.URL.createObjectURL(blob)
      let a = document.createElement('a')
      a.href = url
      a.download = filename
      a.click()
    }

    function onError(error) {
      console.error(error);
    }

    function onComplete() { }

    securedSendRequest.execute('POST', A6aApiUrls.PRINT, data, onSuccess, onError, onComplete, config, null);
  }

  function handlePrintA10(data) {
    const config = { responseType: 'blob' }

    function onSuccess(response) {
      let blob = new Blob([response.data])

      let first = 'A10Report'
      let curDate = format(new Date(), 'yyyyMMddHHmmss')
      let filename = first + curDate + '.pdf'
      let url = window.URL.createObjectURL(blob)
      let a = document.createElement('a')
      a.href = url
      a.download = filename
      a.click()
    }

    function onError(error) {
      console.error(error);
    }

    function onComplete() { }

    securedSendRequest.execute('POST', A6aApiUrls.PRINTA10, data, onSuccess, onError, onComplete, config, null);
  }

  function handlePrintA8A(data) {
    const config = { responseType: 'blob' }

    function onSuccess(response) {
      let blob = new Blob([response.data])

      let first = 'A8AReport'
      let curDate = format(new Date(), 'yyyyMMddHHmmss')
      let filename = first + curDate + '.pdf'
      let url = window.URL.createObjectURL(blob)
      let a = document.createElement('a')
      a.href = url
      a.download = filename
      a.click()
    }

    function onError(error) {
      console.error(error);
    }

    function onComplete() { }

    securedSendRequest.execute('POST', A6aApiUrls.PRINTA8A, data, onSuccess, onError, onComplete, config, null);
  }

  function handleSubmitA6A() {
    if (_.isEmpty(confirmSubmit.a6a)) return

    setLoading(true)
    let data = [...confirmSubmit.a6a]
    const fileForUserDetails = FileForUserGetUserDetails()

    data.forEach((a6a) => {
      if (fileForUserDetails) {
        const { fileForUserId, fileForUserPartyId, fileForUserLoginId } = fileForUserDetails

        a6a['fileForUserId'] = fileForUserId
        a6a['fileForUserPartyId'] = fileForUserPartyId
        a6a['fileForUserLoginId'] = fileForUserLoginId
      }
    })

    try {
      securedSendRequest.execute('POST', A6aApiUrls.SUBMIT_ALL, data,
        (response) => {
          const { errorMessages } = response

          if (!_.isEmpty(errorMessages)) {
            errorMessages.forEach((message) => showNotification('error', message))
          } else {
            showNotification('success', getTranslatedText('A6A', 'submitSuccessMsg'))
            setConfirmSubmit({ open: false, a6a: [] })

            tableRef.current.performRefresh()
          }
        },
        () => showNotification('error', getTranslatedText('A6A', 'submitErrorMsg')),
        () => setLoading(false)
      )
    } catch (error) {
      showNotification('error', getTranslatedText('A6A', 'submitErrorMsg'))
      setLoading(false)
    }
  }

  function handleDeleteA6A() {
    if (!confirmDelete.a6a) return

    setConfirmDelete({ open: false })

    deleteRecord.execute(A6aApiUrls.DELETE, confirmDelete.a6a,
      () => {
      showNotification('success', getTranslatedText('A6A', 'deleteSuccessMsg'))
        setConfirmDelete({ open: false, a6a: null })
        tableRef.current.performRefresh()
      },
      (error) => { console.log(error) }
    )
  }

  function handleDeleteTemplateA6A() {
    if (!confirmDeleteTemplate.a6a) return

    setConfirmDeleteTemplate({ open: false })

    deleteRecord.execute(A6aApiUrls.DELETE, confirmDeleteTemplate.a6a,
      () => {
        showNotification('success', getTranslatedText('A6A', 'templateDeleteSuccessMsg'))
        setConfirmDeleteTemplate({ open: false, a6a: null })
        setA6aTemplateDialog(false)
      },
      (error) => { console.log(error) }
    )
  }

  function handleMassDeleteA6A() {
    if (_.isEmpty(confirmMassDelete.a6a)) return

    setLoading(true)
    try {
      deleteRecord.execute(A6aApiUrls.DELETE_ALL, confirmMassDelete.a6a,
        () => {
          showNotification('success', getTranslatedText('A6A', 'massDeleteSuccessMsg'))
          setConfirmMassDelete({ open: false, a6a: [] })

          tableRef.current.performRefresh()
        },
        () => showNotification('error', getTranslatedText('A6A', 'massDeleteErrorMsg')),
        () => setLoading(false)
      )
    } catch (error) {
      showNotification('error', getTranslatedText('A6A', 'massDeleteErrorMsg'))
      setLoading(false)
    }
  }
  function handleDownloadXMLA6A(data) {
    const config = { responseType: 'blob' }
    
    function onSuccess(response) {
      let blob = new Blob([response.data])
      let fileForUserDetails = FileForUserGetUserDetails();
      const loginId = 'A6ADownload';
      if (fileForUserDetails != null && fileForUserDetails != undefined) {
        loginId = fileForUserDetails.fileForUserLoginId;
      }
      let first = loginId
      let curDate = format(new Date(), 'yyyyMMddHHmmss')
      let filename = first + curDate + '.xml'
      let url = window.URL.createObjectURL(blob)
      let a = document.createElement('a')
      a.href = url
      a.download = filename
      a.click()
    }

    function onError(error) {
      console.error(error);
    }

    function onComplete() { }

    securedSendRequest.execute('POST', A6aApiUrls.DOWNLOADA6AXML, data, onSuccess, onError, onComplete, config, null);
  }

  function DisableEditButton(rowData) {
    return rowData.a6aStatus === 1048 || rowData.a6aStatus === 1
  }

  function DisableDeleteButton(rows) {
    let shouldDisable = false

    rows.forEach((rowData) => {
      if (rowData.a6aStatus !== 1005) {
        shouldDisable = true
      }
    })
    return shouldDisable
  }

  function DisableSubmitButton(rows) {
    let shouldDisable = false

    rows.forEach((rowData) => {
      if (rowData.a6aStatus === 1048 || rowData.a6aStatus === 1) {
        shouldDisable = true
      }
    })

    return shouldDisable
  }

  if (loading) {
    return (
      <CngGridItem xs={12} sm={9} shouldHide={loading ? false : true}>
        <CngBackdrop loading={loading} />
      </CngGridItem>
    )
  }

  return (
    <>
      {sbPartyIdFetched && codeMaintenanceFetched && partyConfigFetched && (
      <Table
        actions={[
          {
            label: getTranslatedText('A6A', 'createA6AButton'),
            buttonProps: {
              color: 'primary', size: 'medium',
              startIcon: <FontAwesomeIcon icon={['fal', 'plus-circle']} />,
              onClick: () => history.push(pathMap.A6A_ADD_VIEW)
            }
          },
          {
            label: getTranslatedText('A6A', 'a6aTemplateButton'),
            buttonProps: {
              color: 'primary', size: 'medium',
              startIcon: <FontAwesomeIcon icon={['fal', 'plus-circle']} />,
              onClick: () => setA6aTemplateDialog(true)
            }
          }
        ]}
        columns={hqAdmin ? hqAdminColumns : columns}
        compact
        checkboxSelection
        fetch={{ url: A6aApiUrls.GET }}
        fetchFilters={[
          { field: 'templateFlag', operator: EQUAL, value: '0' },
          { field: 'partyId', operator: IN, value: sbPartyIdList.length > 0 ? sbPartyIdList : FileForUserGetPartyId() },
          ...filter
        ]}
        filters={filters}
        onRowClick={(rowData) => {
          if (DisableEditButton(rowData)) {
            history.push(`${location.pathname}/view/${rowData.id}`)
          } else {
            history.push(`${location.pathname}/edit/${rowData.id}`)
          }
        }}
        rowActions={[
          {
            label: getTranslatedText('A6A', 'editButton'),
            icon: <FontAwesomeIcon icon={['fal', 'pen']} />,
            disabled: (rowData) => DisableEditButton(rowData),
            onClick: (rowData) => history.push(`${location.pathname}/edit/${rowData.id}`),
            tooltip: (rowData) => DisableEditButton(rowData) ? getTranslatedText('A6A', 'editSentRecords') : null
          },
          {
            icon: <FontAwesomeIcon icon={['fal', 'copy']} />,
            label: getTranslatedText('A6A', 'cloneButton'),
            onClick: handleCloneA6A
          },
          {
            label: getTranslatedText('A6A', 'deleteButton'),
            icon: <FontAwesomeIcon icon={['fal', 'trash']} />,
            disabled: (rowData) => rowData.a6aStatus !== 1005,
            onClick: (rowData) => setConfirmDelete({ open: true, a6a: rowData })
          },
          {
            label: getTranslatedText('A6A', 'printButton'),
            icon: <FontAwesomeIcon icon={['fal', 'print']} />,
            onClick: handleNormalPrint
          },
          {
            label: getTranslatedText('A6A', 'printA10Button'),
            icon: <FontAwesomeIcon icon={['fal', 'print']} />,
            onClick: handlePrintA10
          },
          {
            label: getTranslatedText('A6A', 'printA8AButton'),
            icon: <FontAwesomeIcon icon={['fal', 'print']} />,
            onClick: handlePrintA8A
          },
          {
            label: getTranslatedText('A6A', 'downloadXmlButton'),
            icon: <FontAwesomeIcon icon={['fal', 'download']} />,
            onClick: handleDownloadXMLA6A
          }
        ]}
        selectActions={[
          {
            label: getTranslatedText('A6A', 'submitButton'),
            icon: <FontAwesomeIcon icon={['fal', 'arrow-alt-right']} />,
            buttonProps: { color: 'secondary', size: 'medium' },
            disabled: (rows) => DisableSubmitButton(rows),
            onClick: (rows) => setConfirmSubmit({ open: true, a6a: rows }),
            tooltip: (rows) => DisableSubmitButton(rows) ? getTranslatedText('A6A', 'submitSentRecord') : null
          },
          {
            label: getTranslatedText('A6A', 'deleteButton'),
            icon: <FontAwesomeIcon icon={['fal', 'trash']} />,
            buttonProps: { color: 'secondary', size: 'medium' },
            disabled: (rows) => DisableDeleteButton(rows),
            onClick: (rows) => setConfirmMassDelete({ open: true, a6a: rows }),
            tooltip: (rows) => DisableDeleteButton(rows) ? getTranslatedText('A6A', 'deleteMultipleRecords') : null
          }
        ]}
        showNotification={showNotification}
        sortConfig={{ type: 'column', defaultField: 'createdDate', defaultDirection: 'DESC' }}
        persistSettings
        tableRef={tableRef}
        tablePreference={{ module: 'ACIOCN_A6A', key: 'a6a_table_visible_column' }}
      />)}

      <TemplateSelectDialogWithOptionA6A
        a6aTemplateDialog={a6aTemplateDialog}
        setA6aTemplateDialog={setA6aTemplateDialog}
        showNotification={showNotification}
        isTable={true}
        location={location}
        rowActions={[
          {
            icon: <FontAwesomeIcon icon={['fal', 'pen']} />,
            label: getTranslatedText('A6A', 'editButton'),
            onClick: (rowData) => history.push(`${location.pathname}/edit/${rowData.id}`)
          },
          {
            icon: <FontAwesomeIcon icon={['fal', 'trash']} />,
            label: getTranslatedText('A6A', 'deleteButton'),
            onClick: (rowData) => setConfirmDeleteTemplate({ open: true, a6a: rowData })
          }
        ]}
      />

      <ConfirmDialog
        isConfirmDialogOpen={confirmDelete.open}
        closeDialog={() => setConfirmDelete({ open: false, a6a: null })}
        confirmDialog={handleDeleteA6A}
        content={getTranslatedText('A6A', 'deleteWarningMessage')}
        okMsg={getTranslatedText('A6A', 'okDeleteButton')}
        cancelMsg={getTranslatedText('A6A', 'cancelDeleteButton')}
        title={getTranslatedText('A6A', 'deleteButton')}
      />

      <ConfirmDialog
        isConfirmDialogOpen={confirmDeleteTemplate.open}
        closeDialog={() => setConfirmDeleteTemplate({ open: false, a6a: null })}
        confirmDialog={handleDeleteTemplateA6A}
        content={getTranslatedText('A6A', 'deleteWarningMessage')}
        okMsg={getTranslatedText('A6A', 'okDeleteButton')}
        cancelMsg={getTranslatedText('A6A', 'cancelDeleteButton')}
        title={getTranslatedText('A6A', 'deleteButton')}
      />

      <ConfirmDialog
        isConfirmDialogOpen={confirmMassDelete.open}
        closeDialog={() => setConfirmMassDelete({ open: false, a6a: [] })}
        confirmDialog={handleMassDeleteA6A}
        content={getTranslatedText('A6A', 'deleteWarningMessage')}
        okMsg={getTranslatedText('A6A', 'okDeleteButton')}
        cancelMsg={getTranslatedText('A6A', 'cancelDeleteButton')}
        title={getTranslatedText('A6A', 'deleteButton')}
      />

      <ConfirmDialog
        isConfirmDialogOpen={confirmSubmit.open}
        closeDialog={() => setConfirmSubmit({ open: false, a6a: [] })}
        confirmDialog={handleSubmitA6A}
        content={getTranslatedText('A6A', 'submitRecordDialogContent')}
        okMsg={getTranslatedText('A6A', 'submitButton')}
        cancelMsg={getTranslatedText('A6A', 'cancelButton')}
        title={getTranslatedText('A6A', 'submitButton')}
      />
    </>
  )
}

export default TablePage
